import {
  AppConnectExceptionResponseCode,
  AuthorizeErrorCode,
  CurrencyCode,
  EnvironmentType,
  ExceptionCode,
  FilingType,
  FinanceType,
  Locales,
  MatchLinkErrorCode,
  MerchantType,
  OrdinalNumbers,
  PeakExceptionResponseCode,
  PeriodOptionType,
  PndErrorCode,
  PP30FormErrorCode,
  SortingType,
  TransactionErrorCode,
  TypeOfPerson,
  WhtCerfiticateErrorCode,
} from "@/enums/enums";
import { i18n } from "@/i18n";
import JwtDecode from "jwt-decode";
import { SetInputErrorPP30TransactionByErrorCode } from "./pp30Helper";

const oneYear = 365;

export function NewObject(obj: any) {
  if (obj === "") {
    return "";
  } else {
    return JSON.parse(JSON.stringify(obj));
  }
}
export function CheckIsDevelop() {
  return process.env.VUE_APP_TYPE_ENV <= EnvironmentType.SIT;
}
export function CheckIsMUZE() {
  return process.env.VUE_APP_Is_MUZE == 1;
}

export function GetTypeOfPersonBySearchedAddress(merchantType: MerchantType) {
  switch (merchantType) {
    case MerchantType.OrdinaryPerson:
    case MerchantType.OrdinaryPartnership:
    case MerchantType.Shop:
    case MerchantType.BodyOfPersons:
      return { name: i18n.t("Ordinary_Person"), value: TypeOfPerson.OrdinaryPerson };
      break;
    case MerchantType.JointVenture:
    case MerchantType.Association:
    case MerchantType.Foundation:
    case MerchantType.LimitedLiabilityPartnership:
    case MerchantType.PublicCompanyLimited:
    case MerchantType.CompanyLimited:
    case MerchantType.Others:
      return { name: i18n.t("Legal_Entity"), value: TypeOfPerson.JuristicPerson };
      break;

    default:
      return { name: i18n.t("Legal_Entity") as any, value: TypeOfPerson.JuristicPerson as any };
      break;
  }
}

export function GetCurrencyMenuList() {
  const keys = Object.keys(CurrencyCode);
  const values = Object.values(CurrencyCode);
  const currencyList = [];
  for (let index = 0; index < keys.length; index++) {
    currencyList.push({ currencyCode: keys[index], value: values[index] });
  }
  return currencyList;
}

export function GetCurrencyCode(toCurrencyUid: CurrencyCode) {
  const currencyList = GetCurrencyMenuList();
  const currency = currencyList.find((x) => x.value === toCurrencyUid);
  if (currency) {
    return currency.currencyCode;
  } else {
    return "THB";
  }
}

export function Ones(number: string) {
  const _name = number.ToNumber();
  let name = "";
  switch (_name) {
    case 1:
      name = "One";
      break;
    case 2:
      name = "Two";
      break;
    case 3:
      name = "Three";
      break;
    case 4:
      name = "Four";
      break;
    case 5:
      name = "Five";
      break;
    case 6:
      name = "Six";
      break;
    case 7:
      name = "Seven";
      break;
    case 8:
      name = "Eight";
      break;
    case 9:
      name = "Nine";
      break;
  }
  return name;
}

export function Tens(number: string) {
  const _number = number.ToNumber();
  let name = "";
  switch (_number) {
    case 10:
      name = "Ten";
      break;
    case 11:
      name = "Eleven";
      break;
    case 12:
      name = "Twelve";
      break;
    case 13:
      name = "Thirteen";
      break;
    case 14:
      name = "Fourteen";
      break;
    case 15:
      name = "Fifteen";
      break;
    case 16:
      name = "Sixteen";
      break;
    case 17:
      name = "Seventeen";
      break;
    case 18:
      name = "Eighteen";
      break;
    case 19:
      name = "Nineteen";
      break;
    case 20:
      name = "Twenty";
      break;
    case 30:
      name = "Thirty";
      break;
    case 40:
      name = "Forty";
      break;
    case 50:
      name = "Fifty";
      break;
    case 60:
      name = "Sixty";
      break;
    case 70:
      name = "Seventy";
      break;
    case 80:
      name = "Eighty";
      break;
    case 90:
      name = "Ninety";
      break;
    default:
      if (_number > 0) {
        name = Tens(number.substring(0, 1) + "0") + " " + Ones(number.substring(1));
      }
      break;
  }
  return name;
}

export function ConvertWholeNumber(number: string) {
  let word = "";
  let isDone = false; //test if already translated
  const dblAmt = number.ToNumber();
  //if ((dblAmt > 0) && number.StartsWith("0"))
  if (dblAmt > 0) {
    //test for zero or digit zero in a nuemric

    const numDigits = number.length;
    let pos = 0; //store digit grouping
    let place = ""; //digit grouping name:hundres,thousand,etc...
    switch (numDigits) {
      case 1: //ones' range
        word = Ones(number);
        isDone = true;
        break;
      case 2: //tens' range
        word = Tens(number);
        isDone = true;
        break;
      case 3: //hundreds' range
        pos = (numDigits % 3) + 1;
        place = " Hundred ";
        break;
      case 4: //thousands' range
      case 5:
      case 6:
        pos = (numDigits % 4) + 1;
        place = " Thousand ";
        break;
      case 7: //millions' range
      case 8:
      case 9:
        pos = (numDigits % 7) + 1;
        place = " Million ";
        break;
      case 10: //Billions's range
      case 11:
      case 12:
        pos = (numDigits % 10) + 1;
        place = " Billion ";
        break;
      //add extra case options for anything above Billion...
      default:
        isDone = true;
        break;
    }
    if (!isDone) {
      //if transalation is not done, continue...(Recursion comes in now!!)
      if (number.substring(0, pos) != "0" && number.substring(pos) != "0") {
        try {
          word = ConvertWholeNumber(number.substring(0, pos)) + place + ConvertWholeNumber(number.substring(pos));
        } catch (e) {
          console.log(e);
        }
      } else {
        word = ConvertWholeNumber(number.substring(0, pos)) + ConvertWholeNumber(number.substring(pos));
      }
    }
    //ignore digit grouping names
    if (word.trim() == place.trim()) word = "";
  }

  return word.trim();
}

export function EnglishBaht(amount: number) {
  let bahtTxt = "";
  bahtTxt = amount.FormatMoney().replace(/,/g, "");
  let val = "",
    wholeNo = bahtTxt,
    points = "",
    andStr = "",
    pointStr = "",
    endStr = "",
    endBaht = "Baht";
  const decimalPlace = bahtTxt.indexOf(".");
  if (decimalPlace >= 0) {
    wholeNo = bahtTxt.substring(0, decimalPlace);
    points = bahtTxt.substring(decimalPlace + 1);
    if (Number(points) > 0) {
      if (wholeNo == "0" || !wholeNo) {
        andStr = "";
        endBaht = "";
      } else {
        andStr = "and"; // just to separate whole numbers from points/cents
      }
      endStr = "Satang " + endStr; //Cents

      const satang = points.substring(0, 2);
      pointStr = Tens(satang);
    } else if (wholeNo == "0" || !wholeNo) {
      endBaht = "Zero " + endBaht;
    }
  }
  val = `${ConvertWholeNumber(wholeNo).trim()} ${endBaht} ${andStr} ${pointStr} ${endStr}`;
  return val;
}

export function ThaiBaht(amount: number) {
  let bahtTxt = "";
  let n;
  let bahtTH = "";
  const intValSplit = [];
  if (amount < 0) {
    bahtTH = "ลบ";
    amount = amount * -1;
  }

  bahtTxt = amount.FormatMoney().replace(/,/g, "");
  const num = ["ศูนย์", "หนึ่ง", "สอง", "สาม", "สี่", "ห้า", "หก", "เจ็ด", "แปด", "เก้า", "สิบ"];
  const rank = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];
  const temp = bahtTxt.split(".");
  let intVal: any = temp[0];
  const decVal = temp[1];
  if (bahtTxt.ToNumber() == 0) {
    bahtTH = "ศูนย์บาทถ้วน";
  } else {
    while (intVal) {
      let splitVal = "";
      if (intVal.length > 6) {
        splitVal = intVal.substr(intVal.length - 6, 6);
        intVal = intVal.substr(0, intVal.length - 6);
      } else {
        splitVal = intVal;
        intVal = null;
      }
      intValSplit.push(splitVal);
    }

    intValSplit.reverse();
    let intValSplitCount = intValSplit.length;

    intValSplit.forEach((value) => {
      let intcount = 0;
      for (let i = 0; i < value.length; i++) {
        n = value.substr(i, 1);
        if (n != "0") {
          if (intcount >= 1 && i == value.length - 1 && n == "1") {
            bahtTH += "เอ็ด";
          } else if (i == value.length - 2 && n == "2") {
            bahtTH += "ยี่";
          } else if (i == value.length - 2 && n == "1") {
            bahtTH += "";
          } else {
            bahtTH += num[n.ToNumber()];
          }

          bahtTH += rank[value.length - i - 1];
          intcount++;
        }
      }
      if (intValSplitCount != 1) {
        bahtTH += rank[6];
      }
      intValSplitCount--;
    });

    if (bahtTH.trim().length > 0) {
      bahtTH += "บาท";
    }
    if (decVal == "00") {
      if (bahtTH.trim().length > 0) {
        bahtTH += "ถ้วน";
      }
    } else {
      let deccount = 0;

      for (let i = 0; i < decVal.length; i++) {
        n = decVal.substr(i, 1);
        if (n != "0") {
          if (deccount >= 1 && i == decVal.length - 1 && n == "1") {
            bahtTH += "เอ็ด";
          } else if (i == decVal.length - 2 && n == "2") {
            bahtTH += "ยี่";
          } else if (i == decVal.length - 2 && n == "1") {
            bahtTH += "";
          } else {
            bahtTH += num[n.ToNumber()];
          }
          bahtTH += rank[decVal.length - i - 1];
          deccount++;
        }
      }
      bahtTH += "สตางค์";
    }
  }

  return bahtTH;
}

export function ConvertAmountToThaiWord(amount: number, currencyCode: CurrencyCode) {
  let bahtTHWithCurrency = ThaiBaht(amount);
  if (currencyCode !== CurrencyCode.THB) {
    let decimalWord = "";
    if (amount < 0) {
      decimalWord = "ลบ";
      amount = amount * -1;
    }
    let decimalString = amount.FormatMoney().replace(/,/g, "");
    decimalString = decimalString.substring(decimalString.lastIndexOf(".") + 1);
    const decimalCharArray = decimalString.split("");
    decimalCharArray.forEach((decimalCharArrayMember) => {
      const decimalIntArrayMember = parseInt(decimalCharArrayMember);
      let singleDecimalWord = "";
      switch (decimalIntArrayMember) {
        case 1:
          singleDecimalWord = "หนึ่ง";
          break;
        case 2:
          singleDecimalWord = "สอง";
          break;
        case 3:
          singleDecimalWord = "สาม";
          break;
        case 4:
          singleDecimalWord = "สี่";
          break;
        case 5:
          singleDecimalWord = "ห้า";
          break;
        case 6:
          singleDecimalWord = "หก";
          break;
        case 7:
          singleDecimalWord = "เจ็ด";
          break;
        case 8:
          singleDecimalWord = "แปด";
          break;
        case 9:
          singleDecimalWord = "เก้า";
          break;
        case 0:
          singleDecimalWord = "ศูนย์";
          break;
      }
      decimalWord += singleDecimalWord;
    });
    if (bahtTHWithCurrency.includes("บาท") && bahtTHWithCurrency.includes("สตางค์")) {
      bahtTHWithCurrency = bahtTHWithCurrency.replace("บาท", "จุด");
      bahtTHWithCurrency = bahtTHWithCurrency.replace("สตางค์", "");
      bahtTHWithCurrency = bahtTHWithCurrency.substring(0, bahtTHWithCurrency.lastIndexOf("จุด"));
      bahtTHWithCurrency = `${bahtTHWithCurrency}จุด${decimalWord}`;
    }

    if (bahtTHWithCurrency.includes("บาท") && !bahtTHWithCurrency.includes("สตางค์")) {
      bahtTHWithCurrency = bahtTHWithCurrency.replace("บาท", "");
    }

    if (bahtTHWithCurrency.includes("สตางค์") && !bahtTHWithCurrency.includes("บาท")) {
      bahtTHWithCurrency = `ศูนย์จุด${decimalWord}`;
    }

    bahtTHWithCurrency = `(${GetCurrencyCode(currencyCode)}) ${bahtTHWithCurrency}`;
  }

  return bahtTHWithCurrency;
}

export function ConvertAmountToEnglishWord(amount: number, currencyCode: CurrencyCode) {
  let bahtENWithCurrency = EnglishBaht(amount);

  if (currencyCode != CurrencyCode.THB) {
    let decimalString = amount.FormatMoney().replace(/,/g, "");
    decimalString = decimalString.substring(decimalString.lastIndexOf(".") + 1);
    const decimalCharArray = decimalString.split("");
    let decimalWord = "";
    decimalCharArray.forEach((decimalCharArrayMember) => {
      const decimalIntArrayMember = parseInt(decimalCharArrayMember);
      let singleDecimalWord = "";
      switch (decimalIntArrayMember) {
        case 1:
          singleDecimalWord = "One";
          break;
        case 2:
          singleDecimalWord = "Two";
          break;
        case 3:
          singleDecimalWord = "Three";
          break;
        case 4:
          singleDecimalWord = "Four";
          break;
        case 5:
          singleDecimalWord = "Five";
          break;
        case 6:
          singleDecimalWord = "Six";
          break;
        case 7:
          singleDecimalWord = "Seven";
          break;
        case 8:
          singleDecimalWord = "Eight";
          break;
        case 9:
          singleDecimalWord = "Nine";
          break;
        case 0:
          singleDecimalWord = "Zero";
          break;
      }
      decimalWord = `${decimalWord} ${singleDecimalWord}`;
    });

    if (bahtENWithCurrency.includes(" and ") && bahtENWithCurrency.includes("Satang")) {
      bahtENWithCurrency = bahtENWithCurrency.replace(" and ", "point ");
      bahtENWithCurrency = bahtENWithCurrency.replace("Satang", "");
      bahtENWithCurrency = bahtENWithCurrency.replace("Baht", "");
      bahtENWithCurrency = bahtENWithCurrency.substring(0, bahtENWithCurrency.lastIndexOf("point"));
      bahtENWithCurrency = `${bahtENWithCurrency}point ${decimalWord}`;
    }

    if (bahtENWithCurrency.includes(" and ") && !bahtENWithCurrency.includes("Satang")) {
      bahtENWithCurrency = bahtENWithCurrency.replace(" and ", "");
    }

    if (
      bahtENWithCurrency.includes("Baht") &&
      !bahtENWithCurrency.includes("Satang") &&
      !bahtENWithCurrency.includes(" and ")
    ) {
      bahtENWithCurrency = bahtENWithCurrency.replace("Baht", "");
    }

    if (amount == 0) {
      bahtENWithCurrency = "Zero";
    }

    if (bahtENWithCurrency.includes("Satang") && !bahtENWithCurrency.includes(" and ")) {
      bahtENWithCurrency = `Zero point ${decimalWord}`;
    }

    bahtENWithCurrency = `(${GetCurrencyCode(currencyCode)}) ${bahtENWithCurrency}`;
  }

  return bahtENWithCurrency;
}

export function GetMonthName(index: any | string, language = "th"): any {
  const monthListTh = [
    { fullName: "มกราคม", name: "ม.ค." },
    { fullName: "กุมภาพันธ์", name: "ก.พ." },
    { fullName: "มีนาคม", name: "มี.ค." },
    { fullName: "เมษายน", name: "เม.ย." },
    { fullName: "พฤษภาคม", name: "พ.ค." },
    { fullName: "มิถุนายน", name: "มิ.ย." },
    { fullName: "กรกฎาคม", name: "ก.ค." },
    { fullName: "สิงหาคม", name: "ส.ค." },
    { fullName: "กันยายน", name: "ก.ย." },
    { fullName: "ตุลาคม", name: "ต.ค." },
    { fullName: "พฤศจิกายน", name: "พ.ย." },
    { fullName: "ธันวาคม", name: "ธ.ค." },
  ];

  const monthListEn = [
    { fullName: "January", name: "Jan" },
    { fullName: "February", name: "Feb" },
    { fullName: "March", name: "Mar" },
    { fullName: "April", name: "Apr" },
    { fullName: "May", name: "May" },
    { fullName: "June", name: "Jun" },
    { fullName: "July", name: "July" },
    { fullName: "August", name: "Aug" },
    { fullName: "September", name: "Sep" },
    { fullName: "October", name: "Oct" },
    { fullName: "November", name: "Nov" },
    { fullName: "December", name: "Dec" },
  ];

  if (index == "all") {
    if (language == "th") {
      return monthListTh;
    } else {
      return monthListEn;
    }
  } else {
    if (language == "th") {
      return monthListTh[index];
    } else {
      return monthListEn[index];
    }
  }
}
export function GetPeriod(date: Date) {
  const newDate = new Date(date);
  const year = newDate.getFullYear();
  let month = (newDate.getMonth() + 1).toString();
  month = month.length == 2 ? month : "0" + month;
  return month + "/" + year;
}

export function DownloadURI(url: string) {
  const element = document.createElement("a");
  element.setAttribute("href", url);
  element.style.display = "none";
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}

export function DownloadFileFormUrl(url: string, filename: string) {
  fetch(url)
    .then((response) => response.blob())
    .then((blob) => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    })
    .catch(console.error);
}

function GetMessageAuthorizeErrorCode(errorCode: any) {
  let message: any = "";
  switch (errorCode) {
    case AuthorizeErrorCode.Default:
      message = i18n.t("Something_Wrong");
      break;
    default:
      message = i18n.t("Something_Wrong");
      break;
  }

  return message;
}

function GetMessageTransactionErrorCode(errorCode: any) {
  let message: any = "";
  switch (errorCode) {
    case TransactionErrorCode.Default:
      message = i18n.t("Something_Wrong");
      break;
    case TransactionErrorCode.DuplicateNumber:
      message = i18n.t("Duplicated_Document_Number");
      break;
    case TransactionErrorCode.DataError:
      message = i18n.t("Document_Information_Error");
      break;
    case TransactionErrorCode.CanNotEdit:
      message = i18n.t("Cannot_Edit_Document");
      break;
    case TransactionErrorCode.CanNotVoid:
      message = i18n.t("Cannot_Void_Document");
      break;
    case TransactionErrorCode.DataNotFound:
      message = i18n.t("Document_Not_Found");
      break;
    case TransactionErrorCode.TransactionTypeNotFound:
      message = i18n.t("Document_Type_Not_Found");
      break;
    default:
      message = i18n.t("Something_Wrong");
      break;
  }

  return message;
}

function GetMessageWhtCerfiticateErrorCode(errorCode: any) {
  let message: any = "";
  switch (errorCode) {
    case WhtCerfiticateErrorCode.Default:
      message = i18n.t("Something_Wrong");
      break;
    case WhtCerfiticateErrorCode.DuplicateNumber:
      message = i18n.t("Duplicated_WHT_Number");
      break;
    case WhtCerfiticateErrorCode.DataError:
      message = i18n.t("WHT_Information_Error");
      break;
    case WhtCerfiticateErrorCode.CanNotEdit:
      message = i18n.t("Cannot_Edit_WHT");
      break;
    case WhtCerfiticateErrorCode.CanNotVoid:
      message = i18n.t("Cannot_Void_WHT");
      break;
    case WhtCerfiticateErrorCode.DataNotFound:
      message = i18n.t("WHT_Not_Found");
      break;
    default:
      message = i18n.t("Something_Wrong");
      break;
  }
  return message;
}

function GetExceptionMessageByRealtimeCode(exception: any) {
  let message: any = i18n.t("Something_Wrong");
  if (exception) {
    switch (exception.code) {
      case PeakExceptionResponseCode.LockByPeriod:
        message = i18n.t("Lock_old_entries", { date: exception.content.GetDateFormat() });
        break;
      default:
        message = i18n.t("Something_Wrong");
        break;
    }
  }

  return message;
}

function GetMessagePndErrorCode(exception: any) {
  let message: any = "";
  switch (exception.errorCode) {
    case PndErrorCode.Default:
      message = i18n.t("Something_Wrong");
      break;
    case PndErrorCode.DuplicateNumber:
      message = i18n.t("Duplicated_PND_Number");
      break;
    case PndErrorCode.InsertHaveError:
      message = i18n.t("Create_PND_Failed");
      break;
    case PndErrorCode.DataError:
      message = i18n.t("PND_Information_Error");
      break;
    case PndErrorCode.CanNotEdit:
      message = i18n.t("Cannot_Edit_PND");
      break;
    case PndErrorCode.CreateJournalFailed:
      message = i18n.t("Accounting_Record_Failed");
      break;
    case PndErrorCode.CreateExpenseFailed:
      message = i18n.t("Expenses_Record_Failed");
      break;
    case PndErrorCode.CanNotVoid:
      message = i18n.t("Cannot_Void_PND");
      break;
    case PndErrorCode.DataNotFound:
      message = i18n.t("PND_Not_Found");
      break;
    case PndErrorCode.DuplicateTransactionData:
      message = i18n.t("Duplicate_Document_Error");
      break;
    case PndErrorCode.CanNotVoidCauseByIsClosingEntry:
      message = i18n.t("Recorded_Closing_Error");
      break;
    case PndErrorCode.NumberInvalid:
      message = i18n.t("Alert_PndNumberInvalid");
      break;
    case PndErrorCode.CreateJournalFailedByRealtime:
    case PndErrorCode.CreateExpenseFailedByRealtime:
    case PndErrorCode.VoidJournalFailedByRealtime:
    case PndErrorCode.VoidExpenseFailedByRealtime:
      message = GetExceptionMessageByRealtimeCode(exception.detail.exception);
      break;
    default:
      message = i18n.t("Something_Wrong");
      break;
  }
  return message;
}

function GetMessagePP30ErrorCode(exception: any) {
  let message: any = "";
  switch (exception.errorCode) {
    case PP30FormErrorCode.Default:
      message = i18n.t("Something_Wrong");
      break;
    case PP30FormErrorCode.DuplicateNumber:
      message = i18n.t("Duplicated_PP30_Number");
      break;
    case PP30FormErrorCode.DataError:
      message = i18n.t("PP30_Information_Error");
      break;
    case PP30FormErrorCode.CanNotEdit:
      message = i18n.t("Cannot_Edit_PP30");
      break;
    case PP30FormErrorCode.CreateJournalFailed:
      message = i18n.t("Accounting_Record_Failed");
      break;
    case PP30FormErrorCode.CreateExpenseFailed:
      message = i18n.t("Expenses_Record_Failed");
      break;
    case PP30FormErrorCode.CanNotVoid:
      message = i18n.t("Cannot_Edit_PP30");
      break;
    case PP30FormErrorCode.DataNotFound:
      message = i18n.t("Cannot_Void_PP30");
      break;
    case PP30FormErrorCode.CanNotFiling:
      message = i18n.t("PP30_Not_Found");
      break;
    case PP30FormErrorCode.DuplicateTransactionData:
      message = i18n.t("Duplicate_Document_Error");
      break;
    case PP30FormErrorCode.CanNotVoidCauseByIsClosingEntry:
      message = i18n.t("Recorded_Closing_Error");
      break;
    case PP30FormErrorCode.CreateJournalFailedByRealtime:
    case PP30FormErrorCode.VoidJournalFailedByRealtime:
    case PP30FormErrorCode.CreateExpenseFailedByRealtime:
    case PP30FormErrorCode.VoidExpenseFailedByRealtime:
      message = GetExceptionMessageByRealtimeCode(exception.detail.exception);
      break;
    case PP30FormErrorCode.CannotClosingLockPeriod:
      message = i18n.t("Lock_old_entries", { date: exception.detail.GetDateFormat() });
      break;
    default:
      message = i18n.t("Something_Wrong");
      break;
  }
  return message;
}

function GetMatchLinkErrorMessageByErrorCodeDetail(exception: any) {
  let errorMessage: any = "";
  switch (exception.errorCode) {
    case MatchLinkErrorCode.Default:
      errorMessage = i18n.t("MatchLink_Error_Default");
      break;
    case MatchLinkErrorCode.Unauthorize:
      errorMessage = i18n.t("MatchLink_Error_Unauthorize");
      break;
    case MatchLinkErrorCode.Claimed:
      errorMessage = i18n.t("MatchLink_Error_Claimed");
      break;
    case MatchLinkErrorCode.NotAcceptAgreement:
      errorMessage = i18n.t("MatchLink_Error_NotAcceptAgreement");
      break;
    case MatchLinkErrorCode.InvalidOrMissingVerificationData:
      errorMessage = i18n.t("Registration_Number_Incorrect_Please_Enter");
      break;
    default: {
      errorMessage = exception.errorCode
        ? `${i18n.t("Something_Wrong")} Error Code : ${exception.errorCode}`
        : i18n.t("Something_Wrong");
      break;
    }
  }
  return errorMessage;
}

export function GetMessageExceptionCode(exception: any) {
  let message: any = "";
  switch (exception.exceptionCode) {
    case ExceptionCode.GeneralError:
      message = i18n.t("Something_Wrong") + exception.errorCode ? " Error Code:" + exception.errorCode : "";
      break;
    case ExceptionCode.AuthorizeError:
      message = GetMessageAuthorizeErrorCode(exception.errorCode);
      break;
    case ExceptionCode.TransactionError:
      message = GetMessageTransactionErrorCode(exception.errorCode);
      break;
    case ExceptionCode.WhtCerfiticateError:
      message = GetMessageWhtCerfiticateErrorCode(exception.errorCode);
      break;
    case ExceptionCode.PndError:
      message = GetMessagePndErrorCode(exception);
      break;
    case ExceptionCode.PP30Error:
      message = GetMessagePP30ErrorCode(exception);
      break;
    default:
      message = i18n.t("Something_Wrong") + exception.errorCode ? " Error Code:" + exception.errorCode : "";
      break;
  }
  return message;
}
export function GetErrorMessageByExceptionCode(exception: any) {
  let errorMessage: any = "";
  switch (exception.code) {
    case PeakExceptionResponseCode.OverInvitationUser:
      errorMessage = i18n.t("Over_Invitation_User");
      break;
    case PeakExceptionResponseCode.UserAlreadyMerchant:
      errorMessage = i18n.t("User_Already_Merchant");
      break;
    case PeakExceptionResponseCode.MerchantPackageIsNotAddUser:
      errorMessage = i18n.t("Merchant_Package_Is_Not_Add_User");
      break;
    case PeakExceptionResponseCode.CanNotCreateContactHaveMaximumContact:
      errorMessage = i18n.t("Alert_CantCreateContactMaximum");
      break;
    default:
      errorMessage = exception.code
        ? `${i18n.t("Something_Wrong")} Error Code : ${exception.code}`
        : i18n.t("Something_Wrong");
      break;
  }
  return errorMessage;
}

export function GetAppConnectErrorMessageByExceptionCode(exception: any) {
  let errorMessage: any = "";

  switch (exception.exceptionCode) {
    case AppConnectExceptionResponseCode.MatchLinkError:
      errorMessage = GetMatchLinkErrorMessageByErrorCodeDetail(exception);
      break;
    default:
      errorMessage = exception.exceptionCode
        ? `${i18n.t("Something_Wrong")} Error Code : ${exception.exceptionCode}`
        : i18n.t("Something_Wrong");
      break;
  }

  return errorMessage;
}

export function SetInputErrorByException(inputTemplate: any, exception: any) {
  switch (exception.exceptionCode) {
    case ExceptionCode.TransactionError:
      SetInputErrorPP30TransactionByErrorCode(inputTemplate, exception.errorCode);
      break;
  }
}

export function ValidateFetchData(fromDate: Date, toDate: Date, days: number = oneYear) {
  const timeDiff = Math.abs(new Date(toDate).getTime() - new Date(fromDate).getTime());
  const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
  if (diffDays > days) {
    return true;
  }
  return false;
}

export function GetDateTimePeriod(
  periodOptionType: PeriodOptionType,
  taxPeriodDate: Date,
  financeType = FinanceType.None
) {
  let fromDate = new Date();
  let toDate = new Date();
  const thisDate = new Date();

  switch (periodOptionType) {
    case PeriodOptionType.ThisMonth: {
      fromDate = new Date(thisDate.getFullYear(), thisDate.getMonth(), 1);
      toDate = new Date(thisDate.getFullYear(), thisDate.getMonth() + 1, 0);
      break;
    }
    case PeriodOptionType.LastMonth: {
      fromDate = new Date(thisDate.getFullYear(), thisDate.getMonth() - 1, 1);
      toDate = new Date(thisDate.getFullYear(), thisDate.getMonth(), 0);
      break;
    }
    case PeriodOptionType.ThisYear: {
      fromDate = new Date(thisDate.getFullYear(), 0, 1);
      toDate = new Date(thisDate.getFullYear() + 1, 0, 0);
      break;
    }
    case PeriodOptionType.LastYear: {
      fromDate = new Date(thisDate.getFullYear() - 1, 0, 1);
      toDate = new Date(thisDate.getFullYear(), 0, 0);
      break;
    }

    case PeriodOptionType.Custom: {
      const date = new Date(taxPeriodDate);
      fromDate =
        financeType === FinanceType.OutFlow
          ? new Date(date.getFullYear(), date.getMonth() - 6, 1)
          : new Date(date.getFullYear(), date.getMonth(), 1);
      toDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      break;
    }
  }
  return { fromDate: fromDate, toDate: toDate };
}
export function CompareDataListForSorting(dataListA: any, dataListB: any, sortingType: number) {
  if (sortingType === SortingType.ASC) {
    if (dataListA < dataListB) {
      return -1;
    } else if (dataListA > dataListB) {
      return 1;
    } else {
      return 0;
    }
  } else {
    if (dataListA > dataListB) {
      return -1;
    } else if (dataListA < dataListB) {
      return 1;
    } else {
      return 0;
    }
  }
}

export function GetOrdinalNumber(number: number) {
  let ordinalNumber = "";
  switch (number) {
    case 1:
      ordinalNumber = OrdinalNumbers.First;
      break;
    case 2:
      ordinalNumber = OrdinalNumbers.Second;
      break;
    case 3:
      ordinalNumber = OrdinalNumbers.Third;
      break;
    case 4:
      ordinalNumber = OrdinalNumbers.Fourth;
      break;
    case 5:
      ordinalNumber = OrdinalNumbers.Fifth;
      break;
    case 6:
      ordinalNumber = OrdinalNumbers.Sixth;
      break;
    case 7:
      ordinalNumber = OrdinalNumbers.Seventh;
      break;
    case 8:
      ordinalNumber = OrdinalNumbers.Eighth;
      break;
    case 9:
      ordinalNumber = OrdinalNumbers.Ninth;
      break;
    case 10:
      ordinalNumber = OrdinalNumbers.Tenth;
      break;
  }
  return ordinalNumber;
}

export function GetFilingTypeName(filingType: FilingType, filingRound: number) {
  let filingTypeText: any = "";
  switch (filingType) {
    case FilingType.Normal:
      filingTypeText = i18n.t("Normal_Filing");
      break;
    case FilingType.More:
      filingTypeText =
        i18n.locale == Locales.TH
          ? `${i18n.t("Additional_Filing")} ${filingRound}`
          : `${GetOrdinalNumber(filingRound)} ${i18n.t("Additional_Filing")}`;
      break;
  }
  return filingTypeText;
}

export function GetFileType(fileName: any) {
  let fileType = fileName
    .split(".")
    .pop()
    .toLowerCase();
  switch (fileType) {
    case "heic":
    case "heif":
      fileType = "image/heic";
      break;
    default:
      fileType = "";
      break;
  }
  return fileType;
}

export function CheckLeastOneUppercaseLetter(text: string) {
  const leastOneUppercaseLetter = new RegExp("^(?=.*[A-Z])");
  return leastOneUppercaseLetter.test(text);
}
export function CheckLeastOneNumber(text: string) {
  const leastOneNumber = new RegExp("^(?=.*[0-9])");
  return leastOneNumber.test(text);
}
export function CheckLeastEightCharacters(text: string) {
  const leastEightCharacters = new RegExp("^(?=.{8,})");
  return leastEightCharacters.test(text);
}
export function CheckLeastOneSpecialCharacter(text: string) {
  const leastOneSpecialCharacter = new RegExp("^(?=.*[!@#$%^&*])");
  return leastOneSpecialCharacter.test(text);
}
export function CheckMaxlengthEmail(email: string) {
  return email && email.length <= 256;
}
export function CheckMaxlengthPassword(password: string) {
  return password && password.length <= 40;
}
export function CheckInputValidateError(fields: any, isAlreadyError: boolean) {
  if (!isAlreadyError) {
    Object.values(fields).forEach((field: any) => {
      if (!isAlreadyError && field.validateError) {
        isAlreadyError = field.validateError;
      }
    });
  }
  return isAlreadyError;
}
export function DecodeJwtResponse(credential: any) {
  return JwtDecode(credential);
}

function DetectTabClosing(e: any) {
  const confirmationMessage = "";

  (e || window.event).returnValue = confirmationMessage;
  return confirmationMessage;
}

export function AddDetectTabClosing() {
  window.addEventListener("beforeunload", DetectTabClosing);
}
export function RemoveDetectTabClosing() {
  window.removeEventListener("beforeunload", DetectTabClosing);
}
export function GetTextSearchDate(fromDate: any, toDate: any) {
  if (!fromDate && !toDate) {
    return i18n.t("Select_Date_For_Search");
  } else if (!fromDate && toDate) {
    return i18n.t("Before_Date_For_Search", { date: toDate.GetDateFormat() });
  } else if (fromDate && !toDate) {
    return i18n.t("Onwards_Date_For_Search", { date: fromDate.GetDateFormat() });
  } else if (fromDate && toDate) {
    return `${fromDate.GetDateFormat()} - ${toDate.GetDateFormat()}`;
  } else {
    return "";
  }
}
export function GetTextSearchNetAmount(fromNetAmount: number, toNetAmount: number) {
  if (!fromNetAmount && !toNetAmount) {
    return i18n.t("Select_NetAmount_For_Search");
  } else if (!fromNetAmount && toNetAmount) {
    return i18n.t("LessThan_NetAmount_For_Search", { netAmount: toNetAmount.FormatMoney() });
  } else if (fromNetAmount && !toNetAmount) {
    return i18n.t("Onwards_NetAmount_For_Search", { netAmount: fromNetAmount.FormatMoney() });
  } else if (fromNetAmount && toNetAmount) {
    return `${fromNetAmount.FormatMoney()} - ${toNetAmount.FormatMoney()}`;
  } else {
    return "";
  }
}

export function UnsetOverflowModalBox(unsetOverflow: boolean) {
  const elementIdList = document.querySelectorAll("[id='modalBox']");

  if (elementIdList.length > 0) {
    elementIdList.forEach((elementId) => {
      let element = null;
      element = elementId.getElementsByClassName("modalBox")[0];
      if (element) {
        if (unsetOverflow) {
          element.classList.add("unsetOverflow");
          element.classList.add("isCanNotRemoveCalss");
          setTimeout(() => {
            const elementModalBox = elementId.getElementsByClassName("modalBox")[0];
            elementModalBox.classList.remove("isCanNotRemoveCalss");
          }, 500);
        } else {
          if (!element.classList.contains("isCanNotRemoveCalss")) {
            element.classList.remove("unsetOverflow");
          }
        }
      }
    });
  }
}
